<template>
    <div :class="computedClass">
        <div class="eon-search-criteria">
            <EonInputText :width="width" name="address" label="Adres" v-model="internalValue.address"
                          @update:modelValue="update" :showLabel="true" />
            <EonTimePicker :width="width" name="picker" label="Planowany czas rozpoczęcia od"
                           v-model="internalValue.start"
                           @update:modelValue="update" :showLabel="true" :minDate="getYesterday()" :showTime="false"/>
        </div>
    </div>
</template>

<script>
    import EonInputNumber from "@/components/form/EonInputNumber";
    import EonDropdown from "@/components/form/EonDropdown";
    import EonTimePicker from "@/components/form/EonTimePicker";
    import EonButton from "@/components/form/EonButton";
    import {SystemRole} from "@/utils/SystemRole";
    import EonInputText from "@/components/form/EonInputText";
    import {FontUtils} from "@/utils/FontUtils";

    export default {
        name: "PlannedOutageSearchCriteriaPublic",

        props: {
            modelValue: null,
            mapView: {
                default: false,
            },
        },

        emits: ["update:modelValue", "confirmDelete"],

        mounted() {
            this.unsubscribe = FontUtils.onChange((size) => {
                this.fontSize = size;
            });
        },

        beforeUnmount() {
            if (this.unsubscribe) this.unsubscribe();
        },

        methods: {
            update() {
                this.$emit("update:modelValue", this.internalValue);
            },
            deleteSelected() {
                this.$emit("confirmDelete");
            },
            getYesterday() {
                return (function (d) { d.setDate(d.getDate() - 1); return d; }(new Date()));
            },
        },

        data() {
            return {
                Role: SystemRole,
                fontSize: FontUtils.getFontSize(),
            };
        },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
            computedClass() {
                return this.mapView ? "map-view" : "table-view";
            },
            canDelete() {
                return SystemRole.isAdmin() || SystemRole.isDispatcher();
            },
            width() {
                return this.fontSize === "2" ? "560" : "280";
            },
        },

        components: {
            EonInputText,
            EonButton,
            EonTimePicker,
            EonDropdown,
            EonInputNumber,
        },
    };
</script>

<style lang="less">
@import "../../assets/less/eon-search-criteria.less";
</style>
